import CrudRequest from '@rootCommon/services/crud-request';
import { USER } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { BaseMessageDto, IdType, MultipleIds } from '@rootCommon/types/common';
import { User, UserDto, UserListItem } from '@rootCommon/types/user';
import { Filters } from '@rootCommon/types/filter';

const USER_ADMIN = `${USER}/${ADMIN}`;

class UsersService extends CrudRequest<User, UserDto> {
  constructor() {
    super(USER_ADMIN);
  }

  getListByOrgId = async (filters: Filters, organizationId?: IdType): Promise<UserListItem[]> => {
    const params: Filters & { organizationId?: IdType } = { ...filters };

    if (organizationId) {
      params.organizationId = organizationId;
    }
    const res = await CrudRequest.get<UserListItem[]>(`${USER}/all/${ADMIN}`, { params });

    return res.data;
  };

  getListByGroupId = async (filters: Filters, groupId: IdType): Promise<UserListItem[]> => {
    const params: Filters & { groupId: IdType } = { ...filters, groupId };
    const res = await CrudRequest.get<UserListItem[]>(`${USER}/all/by-group/${ADMIN}`, { params });

    return res.data;
  };

  multipleDelete = async (ids: MultipleIds): Promise<BaseMessageDto> => {
    const res = await CrudRequest.delete<BaseMessageDto>(USER_ADMIN, {
      data: ids,
    });

    return res.data;
  };

  enable = async (ids: MultipleIds): Promise<BaseMessageDto> => {
    const res = await CrudRequest.put<BaseMessageDto, MultipleIds>(`${USER}/enable/${ADMIN}`, ids);

    return res.data;
  };

  lock = async (ids: MultipleIds): Promise<BaseMessageDto> => {
    const res = await CrudRequest.put<BaseMessageDto, MultipleIds>(`${USER}/lock/${ADMIN}`, ids);

    return res.data;
  };

  ungroup = async (ids: MultipleIds): Promise<BaseMessageDto> => {
    const res = await CrudRequest.put<BaseMessageDto, MultipleIds>(`${USER}/ungroup/${ADMIN}`, ids);

    return res.data;
  };

  group = async (ids: MultipleIds, groupId: IdType): Promise<BaseMessageDto> => {
    const res = await CrudRequest.put<BaseMessageDto, MultipleIds & { groupId: IdType }>(`${USER}/group/${ADMIN}`, {
      ...ids,
      groupId,
    });

    return res.data;
  };
}

export default new UsersService();
